import styled from "styled-components";
import { theme } from "../../theme";
import { MediaQuery } from "../../utils/design";

interface Props {
  spacing?: number;
  mw?: string;
  border?: boolean;
  dontClipOverflow?: boolean;
}

const Card = styled.div<Props>`
  background-color: ${theme.colors.white};
  padding: ${(props) =>
    props.spacing !== undefined ? `${props.spacing}rem` : "1rem"};
  border-radius: 8px;
  box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.06);
  border: ${(props) =>
    props.border ? `1px solid ${theme.colors.border}` : "none"};
  max-width: ${(props) => (props.mw ? props.mw : undefined)};
  overflow: ${(props) => (props.dontClipOverflow ? "visible" : "clip")};

  ${MediaQuery.XS} {
    padding: ${(props) => (props.spacing !== 0 ? "1rem" : "0")};
  }
`;

export default Card;
